@if ({
  isLogged: isLogged$ | async,
  }; as content) {
  <div class="simple-card product-card" [ngClass]="{ highlighted }">
    @if (product?.refType) {
      <div class="product-type {{ (product?.refType || '').toLowerCase() }}">{{ product.refType }}</div>
    }
    @if (product?.productReferenceType) {
      <div class="product-reference {{ (product?.productReferenceType?.code || '').toLowerCase() }}">
        {{ product.productReferenceType?.label }}
      </div>
    }
    <product-media [product]="product" [urlTarget]="targetURL"></product-media>
    <h3 class="box-product-name" [title]="product.completeName">
      @if (!product.isCustom) {
        <a
          class="text-common"
          tabindex="0"
          [target]="targetURL"
          [routerLink]="
            {
              cxRoute: 'product',
              params: product,
            } | cxUrl
          "
          >
          {{ fixProductName(product.completeName) }}
        </a>
      } @else {
        @if (product.competitorFlag?.toLowerCase() === 'yes') {
          <span class="text-common"> {{ product.competitorBrand }} - {{ fixProductName(product.name) }} </span>
        } @else {
          <span class="text-common">
            {{ fixProductName(product.name) }}
          </span>
        }
      }
    </h3>
    <div class="box-details" [ngClass]="{ 'is-logged': content.isLogged }">
      @if (content.isLogged) {
        @if (product?.customerPartNumber) {
          <p>
            <span class="title">{{ 'intro.customer' | cxTranslate }}#:</span><span class="value">{{ product?.customerPartNumber }}</span>
          </p>
        }
      }
      @if (product?.partNumber) {
        <p>
          <span class="title">{{ 'intro.part' | cxTranslate }}#:</span><span class="value">{{ product?.partNumber }}</span>
        </p>
      }
      @if (product?.catalogNumber) {
        <p>
          <span class="title">{{ 'intro.catalog' | cxTranslate }}#:</span><span class="value">{{ product?.catalogNumber }}</span>
        </p>
      }
      @if (product?.nonReturnable) {
        <p class="d-flex justify-content-center align-items-center text-warning">
          <span class="title">{{ 'productRow.labels.nonReturnable' | cxTranslate }}</span>
          <tooltip-icon [content]="'cart.cartItems.nonReturnableItemWarning' | cxTranslate"/>
        </p>
      }
    </div>
    @if (!product.isCustom) {
      @if (!product.discontinued) {
        <div class="box-price" [ngClass]="{ 'is-logged': content.isLogged }">
          <product-price [InProduct$]="productAsObservable()" [lazyPrice]="lazyPrice"></product-price>
        </div>
      } @else {
        <span class="ff-bold text-danger">
          {{ 'productRow.noLonger' | cxTranslate }}
        </span>
      }
    }
    <div class="actions w-100">
      @if (!product.isCustom) {
        @if (product.discontinued) {
          <product-replacement [product]="product"></product-replacement>
        } @else {
          @if (content.isLogged) {
            <cx-add-to-cart [productCode]="product.code!" [showQuantity]="false"> </cx-add-to-cart>
          } @else {
            <a tabindex="0" [routerLink]="['/where-to-buy']" class="btn btn-primary w-100">
              <span class="d-flex icon material-symbols-outlined m-r-4"> location_on </span>
              {{ 'productRow.actions.whereToBuy' | cxTranslate }}
            </a>
          }
        }
      }
    </div>
  </div>
}
